import { Flex, Spin } from 'antd';
import { Suspense } from 'react';

export const withSuspense =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: P) =>
    (
      <Suspense
        fallback={
          <Flex
            vertical
            justify="center"
            align="center"
            style={{ width: '100%', height: '100%' }}
          >
            <Spin spinning />
          </Flex>
        }
      >
        <Component {...props} />
      </Suspense>
    );
